import React from "react"
import AvenueImg from "UI/AvenueImg"
import {
  CaseStudyContainer,
  CaseStudyTitle,
  CaseStudyLogo,
  CaseStudyCategoryContainer,
  CaseStudyCategory,
  CaseStudyCategoryName,
  CaseStudyAwardContainer,
  CaseStudyAward,
  CaseStudyAwardName,
  CSImage,
} from "./style"

const CaseStudy = ({ caseStudy }) => {
  console.log(caseStudy)

  // Rename any legacy award labels in the DB
  if (caseStudy?.caseStudy?.type == "Workplace Giving Excellence Awards") {
    caseStudy.caseStudy.type = "Australian Workplace Giving Awards"
  }

  return (
    <CaseStudyContainer>
      <CaseStudyTitle>
        {caseStudy?.caseStudy.type == "Case Study"
          ? ""
          : `${caseStudy?.caseStudy.year} `}
        {caseStudy?.caseStudy.type}
      </CaseStudyTitle>
      <CSImage>
        <AvenueImg fluid={caseStudy?.caseStudy?.logo} />
      </CSImage>

      {caseStudy?.caseStudy.type !== "Case Study" && (
        <>
          <CaseStudyCategoryContainer>
            <CaseStudyCategory>Category</CaseStudyCategory>
            <CaseStudyCategoryName>
              {caseStudy?.caseStudy?.category}
            </CaseStudyCategoryName>
          </CaseStudyCategoryContainer>
          <CaseStudyAwardContainer>
            <CaseStudyAward>Award</CaseStudyAward>
            <CaseStudyAwardName>
              {caseStudy?.caseStudy?.award}
            </CaseStudyAwardName>
          </CaseStudyAwardContainer>
        </>
      )}
    </CaseStudyContainer>
  )
}

export default CaseStudy
